/**
 * Created by vladislav on 21.08.2019
 */
ComingSoonLocationView.prototype.customize = cleverapps.extendFunc(ComingSoonLocationView.prototype.customize, function (...args) {
    this._super(...args);

    const styles = cleverapps.styles.LocationView.coming_soon.clouds;
    const clouds = new cleverapps.Spine(bundles.episodes_resources.jsons.locked_json);
    clouds.setScale(1.4);
    clouds.setAnimation(0, "close", true);
    this.content.addChild(clouds);
    clouds.setAlignment(this.content.width / 2 + styles.offset.x, this.content.height / 2 + styles.offset.y);
    clouds.setLocalZOrder(this.content.getLocalZOrder() - 1);
});
